import {
  Columns,
  Column,
  Stack,
  Box,
  Hidden,
  Text,
  IconAI,
  useResponsiveValue,
} from 'braid-design-system';
import React from 'react';

import { isStandard } from 'src/data/listing-products/products';
import type { ListingProductWithPackageInfo } from 'src/data/listing-products/shared';

import DesktopFeatures from './components/DesktopFeatures/DesktopFeatures';
import MobileFeatures from './components/MobileFeatures/MobileFeatures';
import PackageHeader from './components/PackageHeader/PackageHeader';

import * as styles from './style.css';

interface PackageProps {
  product: ListingProductWithPackageInfo;
}

const Package = ({ product }: PackageProps) => {
  const responsiveValue = useResponsiveValue();

  const isMobile = responsiveValue({
    mobile: true,
    tablet: false,
  });

  return (
    <Column width="1/5">
      <Columns space="none" alignY="bottom" collapseBelow="desktop">
        <Column>
          <Box data-testid={`packages-column-${product.productCode}`}>
            <Stack space="small" align="center">
              {!isMobile && isStandard(product.productCode) && (
                <Text
                  icon={<IconAI />}
                  align="center"
                  weight="strong"
                  tone="promote"
                >
                  Recommended
                </Text>
              )}
              <Box
                className={
                  isStandard(product.productCode)
                    ? styles.variants.promote
                    : styles.variants.info
                }
                width="full"
              >
                <Stack space="medium">
                  <PackageHeader product={product} />

                  <Hidden below="desktop">
                    <DesktopFeatures product={product} />
                  </Hidden>

                  <Hidden above="tablet">
                    <MobileFeatures product={product} />
                  </Hidden>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Column>
      </Columns>
    </Column>
  );
};

export default Package;
